export const isNumericId = (id: string | number): boolean => {
	if (isNaN(Number(id))) {
		return false;
	}

	return Number(id) > 0 && Number.isInteger(Number(id));
};

export const isValidUuid = (id: string): boolean => {
	const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return uuidRegex.test(id);
};

export const createPatternValidator = (pattern: RegExp) => {
	return (id: string): boolean => pattern.test(id);
};

export const createResourceExistenceChecker = <T>(apiCall: (id: string | number) => Promise<T>) => {
	return async (id: string | number): Promise<boolean> => {
		try {
			const response = await apiCall(id);
			return !!response && !(response as any).error;
		} catch (error) {
			return false;
		}
	};
};

const idValidationUtils = {
	isNumericId,
	isValidUuid,
	createPatternValidator,
	createResourceExistenceChecker
};

export default idValidationUtils;
